import * as yup from "yup";

// Both fields are optional (MAX-4403 Q5): a blank Redirect URL means no redirect after sign-up, and
// blank Button Text falls back to Kestrel's "Submit". A URL that is given must still be a full one.
export const registrationFormSchema = {
	redirectUrl: yup
		.string()
		.url("Full URL (http://example.com) is required."),
	buttonText: yup
		.string(),
};
